let $email;
let $emailerror;
let $formalert;
let $btnsubmit;
let $emailloader;
let $clientcode;
let $project;
const loaders = true; // Show spinners?

$(document).ready(() => {
    require('parsleyjs');

    const $form = $('#donotemail-form');

    $formalert = $('#form-alert');
    $btnsubmit = $('button[type="submit"]');

    $email = $('#email');
    $email.on('change keyup blur', UpdateProject);

    $emailloader = $('#email-loader');
    $emailerror = $('#email-error');

    $clientcode = $('#clientcode');
    $clientcode.on('change focus', UpdateProject);

    $project = $('#project');

    // Don't default to a value.
    $clientcode.val('');

    $form.parsley().on('field:validated', () => {
        const ok = $('.parsley-error').length === 0;
        $('.bs-callout-info').toggleClass('hidden', !ok);
        $('.bs-callout-warning').toggleClass('hidden', ok);
    })
        .on('form:submit', form => {
            $formalert.fadeOut();

            $.ajax('./', {
                method: 'POST',
                data: {
                    fields: JSON.stringify(form.fields.map(field => ({ key: field.$element[0].id, value: field.value, }))),
                },
                beforeSend: () => {
                    if (loaders) $btnsubmit.html('Removing.. <i class="fal fa-spin fa-spinner-third"></i>');

                    // Lock up inputs
                    $btnsubmit.prop('disabled', true);
                    $email.prop('disabled', true).addClass('disabled');
                    $clientcode.prop('disabled', true);
                    $project.prop('disabled', true);
                    $('#note').prop('disabled', true);
                },
                complete: () => {
                    if (loaders) $btnsubmit.html('Remove');

                    // Unlock inputs
                    $btnsubmit.prop('disabled', false);
                    $email.prop('disabled', false).removeClass('disabled');
                    $clientcode.prop('disabled', false);
                    $project.prop('disabled', false);
                    $('#note').prop('disabled', false);
                },
            }).then(response => {
                if (!response.success) {
                    $formalert
                        .removeClass(`alert-${$formalert.attr('data-style')}`) // Remove current know style
                        .attr('data-style', 'danger') // Store upcoming style
                        .addClass('alert-danger') // Yadda Yadda
                        .fadeIn(); // Display
                    $formalert
                        .find('#alert-content')
                        .text(`An error has occured while trying to unsubscribe you from the ${response.client} ${response.project} list.`);
                } else {
                    $formalert
                        .removeClass(`alert-${$formalert.attr('data-style')}`) // Remove current know style
                        .attr('data-style', 'success') // Store upcoming style
                        .addClass('alert-success') // Yadda Yadda
                        .fadeIn(); // Display
                    $formalert
                        .find('#alert-content')
                        .text(`You have been unsubscribed from the ${response.client} ${response.project} list.`);

                    // Remove parsley coloring
                    $email.removeClass('parsley-success parsley-error');
                    $clientcode.removeClass('parsley-success parsley-error');
                    $project.removeClass('parsley-success parsley-error');
                    $('#note').removeClass('parsley-success parsley-error');
                    UpdateProject('email');
                }
            }).catch(false);
            return false;
        });

    // Prefill client and project if specified
    const params = {};
    window.location.search.slice(1).split('&').forEach(keyvalue => {
        const queryArray = keyvalue.split('=');
        params[queryArray[0].toLowerCase()] = decodeURI(queryArray[1]);
    });

    // If we have a clientcode query
    if (params.c) {

        // Grab our client
        const $clientOption = $clientcode.find(`option[value="${params.c}"]`);

        // If we have the passed clientcode as an option
        if ($clientOption.length) {

            // Select option
            $clientOption.prop('selected', true);

            // Hide clientcode selector, trigger event.
            $clientcode
                .hide()
                .change();

            // Update the label
            $('label[for="clientcode"]').text(`Client: ${params.c}`);
        }

        // If we have a project query
        if (params.p) {

            // Wait for the project dropdown to populate
            $project.bind('DOMSubtreeModified', () => {

                // Grab our project
                const $projectOption = $project.find(`option[value="${params.p}"]`);

                // If we have the passed project as an option
                if ($projectOption.length) {

                    // Select option
                    $projectOption.prop('selected', true);

                    // Hide project selector, trigger event
                    $project
                        .hide()
                        .change();

                    // Update the label
                    $('label[for="project"]').text(`Project: ${params.p}`);
                }

            });
        }
    }
});

// Prevent form post to new page
$('form').on('submit', false);

// Hide and show alert without destroying element
$('#alert-hide').on('click', function () { $(this).parent().fadeToggle(); });


const UpdateProject = function (initiatorOverride = false) {
    // May be a jquery event depending on usage.
    if (typeof initiatorOverride !== 'string') initiatorOverride = false;

    // Determine our initiator to figure out if we're updating the client code or the project
    const initiator = initiatorOverride || $(this)[0].id;

    // If checking by email, don't send wasteful requests until there's at least 3 characters typed.
    if (initiator === 'email' && $email.val().length <= 3) return;

    $.ajax('./update-project', {
        method: 'POST',
        data: {
            email: $email.val(),
            clientcode: $clientcode.val(),
        },
        beforeSend: () => {
            if (initiator !== 'email') return;
            if (loaders) $emailloader.addClass('active');
        },
        error: err => {
            $emailerror.text(err).addClass('active');
            $project.empty();
        },
    }).then(response => {

        // Empty out fields if triggered by the email field.
        if (initiator === 'email') {
            // $clientcode.find('option').each((index, option) => $(option).remove());
            $project.find('option').each((index, option) => $(option).remove());
        }

        // Client code selection recreates the project select.
        if (initiator === 'clientcode') $project.find('option').each((index, option) => $(option).remove());

        // Can't parse the response, expecting an array, break free.
        if (!Array.isArray(response)) return;

        if (initiator === 'email' && loaders) $emailloader.removeClass('active');
        if (response.length === 0 && $clientcode.val() !== null) {
            // $clientcode.empty();
            $project.empty();
            return $emailerror.addClass('active');
        }

        // We passed so if we still had an error, remove it.
        $emailerror.removeClass('active');

        response.forEach(object => {

            // If result isn't attached to this email anymore, don't handle it.
            // This could happen when a user is still typing their email.
            // if (object.email !== $email.val()) return;

            switch (initiator) {
                // On clientcode change, update project entries.
                case 'clientcode':
                    // Do not add to select if already exists or not for current selected client.
                    if ($project.find(`option[value="${object.ProjName}"]`).length > 0 || object.clientcode !== $clientcode.val()) return;
                    $project.append(`<option value="${object.ProjName}">${object.ProjName === 'General Opt In' ? 'General' : object.ProjName}</option>`);
                    break;

                // Default or email initiator, update both project and clientcode fields.
                case 'email':
                default:
            }
        });

        // As long as we have a client code and we've been initiated through interaction with the client code selector, add a general opt-in choice to the bottom of the project selector.
        // if ($clientcode.find('option').length > 0 && initiator === 'clientcode') $project.prepend('<option value="General Opt In">General Opt-In</option>');

        // Force an update event on the clientcode selector
        if (initiator !== 'clientcode') $clientcode.change();

    }).catch(console.error);
};
